import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ModalData {
  [key: string]: any
}

export interface ModalState {
  [key: string]: any
}

const initialState: ModalState = {}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModal: (state, action: PayloadAction<ModalData>) => {
      return { ...state, ...action.payload }
    },
    unsetModal: () => {
      return {}
    },
  },
})

export const { setModal, unsetModal } = modalSlice.actions
export default modalSlice.reducer